import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useDebounce from "../../hooks/useDebounce";
import { searchAgents } from "../../lib/api"; // <-- ensure this path is correct
import verifiedImage from "../../Images/Content/verified.png";
import "./AgentSearch.css";

export default function AgentSearch() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [touched, setTouched] = useState(false);

  // Debounce the query so we don't call on every keystroke
  const qDebounced = useDebounce(query, 300);

  useEffect(() => {
    let alive = true;

    async function run() {
      // Only search when 3+ characters
      if (!qDebounced || qDebounced.trim().length < 3) {
        if (alive) setResults([]);
        return;
      }
      setLoading(true);
      const data = await searchAgents(qDebounced.trim());
      if (alive) {
        setResults(Array.isArray(data) ? data : []);
        setLoading(false);
      }
    }

    run();
    return () => {
      alive = false;
    };
  }, [qDebounced]);

  return (
    <div
      className="agent-search-page"
      style={{ maxWidth: 720, margin: "0 auto", padding: "1rem" }}
    >
      <h1 style={{ marginBottom: 8 }}>Verify Your Agent</h1>
      <p style={{ marginTop: 0, color: "#666" }}>
        Type at least <strong>3 characters</strong> of a first name, last name,
        or NPN.
      </p>

      <input
        type="text"
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          setTouched(true);
        }}
        placeholder="Search by name or NPN…"
        aria-label="Search by name or NPN"
        style={{
          width: "100%",
          padding: "12px 14px",
          borderRadius: 8,
          border: "1px solid #ccc",
          outline: "none",
          fontSize: 16,
        }}
      />

      {/* Helper / status text */}
      <div style={{ minHeight: 24, marginTop: 8, color: "#555" }}>
        {loading && <span>Searching…</span>}
        {!loading &&
          touched &&
          query.trim().length > 0 &&
          query.trim().length < 3 && (
            <span>Keep typing… enter at least 3 characters.</span>
          )}
        {!loading && qDebounced.trim().length >= 3 && results.length === 0 && (
          <span>No agents found.</span>
        )}
      </div>

      {/* Results list */}
      <ul style={{ listStyle: "none", padding: 0, marginTop: 12 }}>
        {results.map((a) => (
          <li
            key={a.slug || a.npn}
            style={{
              border: "1px solid #eee",
              borderRadius: 10,
              padding: 12,
              marginBottom: 10,
              display: "flex",
              alignItems: "center",
              gap: 12,
            }}
          >
            {/* Headshot (optional) */}
            {a.headshotUrl ? (
              <img
                src={a.headshotUrl}
                alt={`${a.firstName} ${a.lastName}`}
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
                loading="lazy"
              />
            ) : (
              <div
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: "50%",
                  background: "#f0f0f0",
                  display: "grid",
                  placeItems: "center",
                  color: "#999",
                }}
              >
                ?
              </div>
            )}

            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600 }}>
                {a.firstName} {a.lastName}
              </div>
              <div style={{ color: "#666", fontSize: 14 }}>NPN: {a.npn}</div>

              {/* Licensed states chips */}
              <div
                style={{
                  marginTop: 6,
                  display: "flex",
                  gap: 6,
                  flexWrap: "wrap",
                }}
              >
                {(a.licenses || []).slice(0, 6).map((l) => (
                  <span
                    key={l.state}
                    style={{
                      fontSize: 12,
                      padding: "2px 8px",
                      borderRadius: 999,
                      border: "1px solid #ddd",
                      background: "#fafafa",
                    }}
                  >
                    {l.state}
                  </span>
                ))}
                {(a.licenses || []).length > 6 && (
                  <span style={{ fontSize: 12, color: "#666" }}>
                    +{(a.licenses || []).length - 6} more
                  </span>
                )}
              </div>
            </div>

            {/* Link to profile */}
            <Link
              to={`/agent/${encodeURIComponent(a.slug || a.npn)}`}
              style={{
                textDecoration: "none",
                background: "#0a4e85",
                color: "white",
                padding: "8px 12px",
                borderRadius: 8,
              }}
            >
              View
            </Link>
          </li>
        ))}
      </ul>
      <div className="meda-verified-pic">
        <img className="verified-pic" src={verifiedImage}></img>
      </div>
    </div>
  );
}
